export const appSettingsInternalUserGroupsInternalUserGroupId = "/internal_user_groups/:internal_user_group_id";
